import React, { useRef, useEffect, useCallback, useState} from 'react';
import {subscribe, unsubscribe} from 'messaging/queue.js';
import EdgeHelper from './EdgeHelper.js';
import {
    setSelectedPianoRollSteps,
    setSelectedPadEdge} from 'actions/index.js';
import {connect} from 'react-redux';
import {getPath} from "components/effects/rack/getPath.js";
import {getSegmentedPath} from "./getSegmentedPath.js";
import Arrow from "components/effects/rack/Arrow.js";
import './edges.scss';

const MessagingEdge = ({
    isMoving,
    drawingEdge,
    edgesPadding,
    containerRef,
    selection,
    inlet,
    outlet,
    isSelected,
    setSelectedPadEdge,
    setSelectedSteps,
    fromPosition,
    toPosition,
    isSourceCollapsed,
    isDestCollapsed,
    edge,
    segmentation,
    edgesRef,
    presentationMode,
}) => { 
    let [points, setPoints] = useState([]);
    let [received, setReceived] = useState(false);
    let toEl = useRef(undefined);
    let fromEl = useRef(undefined);
    let [hovered, setHovered] = useState(false);

    useEffect(() => {
        let type = outlet.sourceEl;
        if (hovered) {
            subscribe(type, onMessage);
        } else {
            unsubscribe(type, onMessage);
            setReceived(undefined);
        }
    }, [outlet, hovered, setReceived]);

    const onMessage = useCallback((msg) => {
        let _msg = outlet.sourceType;
        try {
            _msg += "." + JSON.stringify(msg);
        } catch (e) {
        }
        setReceived(_msg);
    }, [onMessage, setReceived]);

    useEffect(() => {
        drawEdge();
    }, [setPoints, inlet, outlet, fromPosition, toPosition, isSourceCollapsed, isDestCollapsed, edgesPadding]);

    const drawEdge = useCallback((secondCall=false) => {
        if (!containerRef.current) {
            return;
        }
        
        if (!toEl.current) {
            toEl.current = document.getElementById(outlet.destEl);
        }
        if (!fromEl.current) {
            fromEl.current = document.getElementById(outlet.sourceEl);
        }
        
        if (!toEl.current || !fromEl.current || (toEl.current && !toEl.current.isConnected) ||
            (fromEl.current && !fromEl.current.isConnected)) {
            setPoints([]);
            return;
        }
        let _fromEl = fromEl.current.getBoundingClientRect();
        let _toEl = toEl.current.getBoundingClientRect();
        
        let rect = edgesRef.current.getBoundingClientRect();
        let top = rect.top;
        let left = rect.left;

        let pts = [_fromEl.left - left, _fromEl.top - top, _toEl.left - left, _toEl.top - top];

        if (window._scale !== 1) {
            pts = pts.map(x => x / (window._scale || 1));
        }

        if (pts.length === 0 && !secondCall) {
            setTimeout(() => {
                drawEdge(true);
            }, 100);
        } else {
            setPoints(pts);
        }
    }, [setPoints, inlet, outlet, fromPosition, toPosition, isSourceCollapsed, isDestCollapsed]);

    useEffect(() => {
        setTimeout(() => {
            drawEdge();
        }, 80);
    }, [setPoints, presentationMode, inlet, outlet]);


    if (points.length === 0) {
        return [];
    }

    let [x1,y1,x2,y2] = points;
    let className = "pad-effect-edge message-edge ";
    if (isSelected) {
        className += " selected";
    }

    let midX = (x1+x2)/2;
    let midY = (y1+y2)/2;

    let isHorizontal = toEl.current && toEl.current.parentElement.className === "inlet-field";
    let pathPoints = segmentation ? getSegmentedPath(x1+5, y1, x2+5, y2+4) : getPath(x1+5,y1,x2+5,y2+4, isHorizontal);

    if (isMoving) {
        return [];
    }

    let gClass = "message-edge-group";
    if (isSelected) {
        gClass += " selected";
    }
    return (
        <g className={gClass}>
          <Arrow
            markerEnd={""}
            onMouseOver={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            segmentation={segmentation}
            onMouseDown={(e) => {
                e.stopPropagation();
                setSelectedPadEdge({id: edge.id, inlet, outlet});
                setSelectedSteps([]);
            }}
            className={className} points={
                pathPoints
            }
          />
          {isSelected && <EdgeHelper edge={edge} pathPoints={pathPoints}/>}
          {received &&
           <g>
             <rect fill="black" x={midX} y={midY} height={20} width={(2 + received.length)+"ch"}>
           </rect>
             <text fill="white" x={midX+5} y={midY+12} fontSize="8pt">
               {received}
             </text>
           </g>
          }
        </g>
    );
};

const mapStateToProps = (state, props) => {
    let fromId = props.outlet.sourceWindowId;
    let toId = props.outlet.destWindowId;
    let _fromId = props.outlet.sourceId;
    let _toId = props.outlet.destId;
    let {movingEdge, drawingEdge, selectedEdge} = state.pads;
    let edge = props.edge;
    return {
        isSourceCollapsed: state.effects.effectCollapsed[fromId],
        isDestCollapsed: state.effects.effectCollapsed[toId],
        isSelected: selectedEdge && selectedEdge.outlet === props.outlet &&
            selectedEdge.inlet === props.inlet,
        isMoving: movingEdge && movingEdge.edge.id === edge.id,
        fromPosition: state.windows.windowPositions[fromId] ||
            state.windows.windowPositions[_fromId],
        toPosition: state.windows.windowPositions[toId] ||
            state.windows.windowPositions[_toId],
        segmentation: state.spatial.cableSegmentations[props.edge.id],
        edgesPadding: state.spatial.edgesPadding,
        presentationMode: state.spatial.presentationMode,
        movingEdge,
    };
};

const mapDispatchToProps = (dispatch) => {
  return {
      setSelectedPadEdge: x=>dispatch(setSelectedPadEdge(x)),
      setSelectedSteps: x=>dispatch(setSelectedPianoRollSteps(x))     
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MessagingEdge);
